import ArbitrageOrderDetailInquiry from './arbitrage-order-detail-inquiry.vue'
export default ArbitrageOrderDetailInquiry
